module.exports = __webpack_public_path__ + "media/images/posts/organizer-98ae56338ea7ee7d56e8592c1a479354.jpg";